import Link from 'next/link'

interface TagBadgeProps {
  tag: {
    slug: string
    name: string
  }
  locale: string
}

export function TagBadge({ tag, locale }: TagBadgeProps) {
  return (
    <Link href={`/blog/${locale}/tag/${tag.slug}`}>
      <span className="inline-flex items-center rounded-full border border-indigo-200 bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700 transition-all duration-200 hover:border-indigo-300 hover:bg-indigo-100 dark:border-indigo-500/30 dark:bg-indigo-500/10 dark:text-indigo-300 dark:hover:border-indigo-400/40 dark:hover:bg-indigo-500/15">
        {tag.name}
      </span>
    </Link>
  )
}
